import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUserService } from '../../user/user.service';
import { ListViewMode } from '../../user/user.store';
import { ProjectsListControls } from '../components/ProjectsListControls';
import { useProjectsService } from '../projects.service';

export const ProjectsListControlsContainer = observer((): ReactElement => {
  const projectsService = useProjectsService();
  const userService = useInjection(IUserService.$);

  const handleOrderByChange = async (orderBy: string): Promise<void> => {
    await projectsService.changeOrder(orderBy, projectsService.store.projectsPaging.orderType || 'asc');
  };

  const handleOrderDirectionChange = async (orderType: string): Promise<void> => {
    await projectsService.changeOrder(projectsService.store.projectsPaging.orderBy || 'name', orderType);
  };

  const handleViewModeChange = async (mode: ListViewMode): Promise<void> => {
    await userService.setProjectsListViewMode(mode);
  };

  const projectsStore = projectsService.store;

  return (
    <ProjectsListControls
      viewMode={userService.data.projectListViewMode}
      orderBy={projectsStore.projectsPaging.orderBy}
      orderDirection={projectsStore.projectsPaging.orderType}
      onViewModeChange={handleViewModeChange}
      onOrderByChange={handleOrderByChange}
      onOrderDirectionChange={handleOrderDirectionChange}
    />
  );
});
